

import { Box, Button, Grid, Modal, TextField, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { generateResponsiveStyle } from "../utils/modalStyle";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

interface TitanCriteriaProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    data: any;
}

const QualityCriteria = ({
    open,
    onClose,
    setOpen,
    data,
}: TitanCriteriaProps) => {
    const style = generateResponsiveStyle();

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="modal_title">
                    <Typography id="modal-modal-title" component="h2">
                        Quality Score Criteria
                    </Typography>
                    <CloseIcon
                        className="cross_icn_logout"
                        onClick={() => setOpen(false)}
                    />
                </div>

                <div className="modal_body">
                    <ul className="criteria_list" style={{ listStyle: "none" }}>
                        {data?.complete?.map((item: string) => (
                            <li >
                                <span className={'success'}>
                                    <DoneIcon />
                                </span>
                                {item}
                            </li>
                        ))}
                    </ul>
                    <ul className="criteria_list" style={{ listStyle: "none" }}>
                        {data?.incomplete?.map((item: string) => (
                            <li >
                                <span className={'danger'}>
                                    <CloseIcon />
                                </span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </Box>
        </Modal>
    );
};

export default QualityCriteria;
